"use client";

import { useLayoutEffect, useRef, useState } from "react";
import { codeCopyButtonClassName } from "@/components/mdx/code-copy-button-classes";
import { CopyButton } from "@/components/ui/copy-button";
import { cn } from "@/lib/utils";

// biome-ignore lint/suspicious/noExplicitAny: Rehype output
export function CodeBlockFigure(props: any) {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const [codeText, setCodeText] = useState("");

	const isCodeBlock = props["data-rehype-pretty-code-figure"] !== undefined;
	const figureClassName = cn("not-prose", props.className);

	useLayoutEffect(() => {
		if (!isCodeBlock) return;
		const code = wrapperRef.current?.querySelector("code");
		setCodeText(code?.textContent ?? "");
	}, [isCodeBlock]);

	if (!isCodeBlock) {
		return <figure {...props} className={figureClassName} />;
	}

	return (
		<div ref={wrapperRef} className="group/code relative">
			<figure {...props} className={figureClassName} />
			{codeText ? (
				<CopyButton
					value={codeText}
					aria-label="Copy code"
					className={codeCopyButtonClassName}
				/>
			) : null}
		</div>
	);
}
